// extracted by mini-css-extract-plugin
export var checkbox = "_8g-0";
export var circle = "_8g-3";
export var horizontalContainer = "_8g-7";
export var sm = "_8g-5";
export var switch0 = "_8g-2";
export var switchDisabled = "_8g-8";
export var switchEnabled = "_8g-1";
export var textSwitchContainer = "_8g-9";
export var textSwitchOption = "_8g-a";
export var textSwitchOptionSelected = "_8g-b";
export var verticalContainer = "_8g-6";
export var xs = "_8g-4";